<template>
  <Footer :columns="columns" />
</template>

<script>
import Footer from 'chimera/all/themes/blueflow/components/layout/Footer'

export default {
  components: {
    Footer,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      columns: [
        {
          title: 'Über uns',
          links: [
            {
              text: 'Kontakt',
              to: '/kontakt-aufnehmen',
            },
          ],
        },
        {
          title: 'Spezialisten',
          links: [
            {
              text: 'Melden Sie sich als Spezialist an',
              to: '/kontakt-fur-unternehmen',
            },
          ],
        },
      ],
    }
  },
}
</script>
